import { render } from "./SPVReport.vue?vue&type=template&id=53f03c1d&scoped=true"
import script from "./SPVReport.vue?vue&type=script&lang=js"
export * from "./SPVReport.vue?vue&type=script&lang=js"

import "./SPVReport.vue?vue&type=style&index=0&id=53f03c1d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53f03c1d"]])

export default __exports__